module.exports = __webpack_public_path__ + "img/buessiness_zotl_c1.7f8fdf2d.png";